/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box } from '@mui/material';
import { OverlayPluginMenuListItem } from './OverlayPluginMenuListItem';
import { usePluginCatalog } from '../../api/hooks';

interface OverlayPluginMenuListProps {
  activePluginIds: string[];
  onPluginToggle: (pluginId: string, isActive: boolean) => void;
}

export const OverlayPluginMenuList = ({
  activePluginIds,
  onPluginToggle,
}: OverlayPluginMenuListProps): React.JSX.Element => {
  const { data: pluginRegistry } = usePluginCatalog();

  const overlayPlugins = Object.values(pluginRegistry || []).filter(
    (plugin) => plugin.type === 'overlay',
  );

  return (
    <Box
      data-testid="overlay-plugin-menu-list"
      sx={{
        width: '336px',
        height: '200px',
        backgroundColor: 'white',
        padding: '5px',
        borderRadius: '4px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        overflowY: 'auto',
      }}
    >
      {overlayPlugins.map((plugin) => (
        <OverlayPluginMenuListItem
          isActive={activePluginIds.includes(plugin.id)}
          key={plugin.id}
          onToggle={onPluginToggle}
          pluginId={plugin.id}
          pluginName={plugin.name}
        />
      ))}
    </Box>
  );
};
